import { render, staticRenderFns } from "./ReportPmtaRelayDeliverability.vue?vue&type=template&id=611b7416&scoped=true"
import script from "./ReportPmtaRelayDeliverability.vue?vue&type=script&lang=js"
export * from "./ReportPmtaRelayDeliverability.vue?vue&type=script&lang=js"
import style0 from "./ReportPmtaRelayDeliverability.vue?vue&type=style&index=0&id=611b7416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b7416",
  null
  
)

export default component.exports